/* eslint-disable class-methods-use-this */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { MonicaObject } from '../../item';
import MasterItemCollection from '../../collection/MasterItemCollection';
import { ObjectType } from '../../../view3d/webcad/ObjectType';
import ItemSearchUtil from '../../util/ItemSearchUtil';
import ItemDetailUtil from '../../util/ItemDetailUtil';

const TEXTURE_WRAP_SELECTOR = '#dialogTextureAndItemStarts2D .textureWrap';
const TEXTURE_ITEM_SELECTOR = '#dialogTextureAndItemStarts2D .textureChangeList li';
const ITEM_ID_ATTRIBUTE = 'data-name';
const ACTIVE_CLASS = 'is-active';
const EVENT_CLICK = 'click';
const EVENT_SCROLL = 'scroll';
const INSERT_POSITION_END = 'beforeend';

/**
 * 3Dーテクスチャ変更
 * 対象：壁、床、天井
 */
export default class TextureAndItemDialogStarts2D extends Dialog {
  public target: any = undefined;

  public $tree: any = null;

  static saveState: { tabId: string, selectCategory: string } = { tabId: 'tab_2', selectCategory: 'all' };

  static tabId = 'tab_2';

  public itemListHtmlStr = ''; // 画像読み込み高速化のために外に置く

  private isReady:boolean = false;

  private alternativeEndItemList:MasterItemCollection[] = [];

  private selectedEndItem: MasterItemCollection = null;

  /**
   * コンストラクタ
   */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
   * ダイアログを中心へ
   */
  public centerDialog() {
    if (this.isReady) {
      // window-heightに対する、ダイアログ高さ調整
      const h1: number = this.viewObj.querySelector('.dialogBody').getBoundingClientRect().height;

      const dialogFooter = this.viewObj.querySelector('.dialogFooter');

      const h2: number = (dialogFooter) ? this.viewObj.querySelector('.dialogFooter').getBoundingClientRect().height : 0;
      if (window.innerHeight <= (h1 + h2 + 120)) {
        (this.viewObj.querySelector('.dialogBody') as HTMLElement).style.height = `${window.innerHeight - h2 - 120}px`;
      }

      // ダイアログの幅調整
      let maxW: number = 0;
      for (let i: number = 0; i < this.viewObj.children.length; i += 1) {
        const w:number = this.viewObj.children[i].getBoundingClientRect().width;
        if (maxW < w) {
          maxW = Math.ceil(w);
        }
        (this.viewObj.children[i] as HTMLElement).style.display = 'block';
      }
      this.viewObj.style.width = `${maxW}px`;

      // ダイアログの高さ調整
      let boxHeight: number = 0;
      for (let i:number = 0; i < this.viewObj.children.length; i += 1) {
        boxHeight += this.viewObj.children[i].getBoundingClientRect().height;
      }
      this.viewObj.style.height = `${boxHeight}px`;
    }
  }

  buildContent() {
    let dummyID:string = 'wallpaper';

    // データがなければ取得しにいく
    if (marietta.webcad.WebCADGlobal.masterManager.getGroupListForId(dummyID)) {
      // リスト生成
      this.buildContentAfterCheck();
    } else {
      const currentSelection:MasterItemCollection = marietta.webcad.WebCADGlobal.itemManager.getCeilingEndItem(this.target.itemInfo.guid);

      // データをサーバから取得
      marietta.webcad.WebCADGlobal.showBusy('商品データ取得中...');
      const p = new Promise((resolve: Function) => {
        if (currentSelection == null) {
          marietta.webcad.WebCADGlobal.masterManager.getSymbolItemsMasterData(dummyID, resolve);
        } else {
          marietta.webcad.WebCADGlobal.masterManager.getGroupItemsMasterData(currentSelection.item_id, resolve);
        }
      });
      p.then((list:any[] = []) => {
        this.alternativeEndItemList = [];
        for (let i:number = 0; i < list.length; i++) {
          let master:MasterItemCollection = new MasterItemCollection(list[i]);
          this.alternativeEndItemList.push(master);
        }
        ItemSearchUtil.moveToFront(this.alternativeEndItemList, currentSelection?.item_id);
        this.buildContentAfterCheck();
        marietta.webcad.WebCADGlobal.hideBusy();
      });
    }
  }

  buildContentAfterCheck() {
    // ダイアログのコンテンツ生成
    const id = 'dialogTextureAndItemStarts2D';

    // タイトル
    let title:string = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '天井材変更'; break;
      default: title = 'Texture'; break;
    }
    let contents:string = '<div class="dialogTextureAndItemStarts2D">\n';
    contents += '<div class="dialogBodyInner">\n';
    contents += '<div class="textureWrap">';
    contents += ItemSearchUtil.createSearchBoxHtml();
    contents += '<div class="textureChangeList"></div>';
    contents += ItemSearchUtil.createEmptyMessageHtml();
    contents += '</div>';
    contents += '</div>';
    contents += '</div>';
    contents += '</div>';

    this.createDialog(id, title, contents, ItemDetailUtil.APPLY_FOOTER_HTML);
    this.setTextureSelectEvent();

    // document.getElementById('dialogTextureAndItemStarts').classList.add(`${this.site(this.target) ? 'siteMode' : 'notSiteMode'}`);
    this.createTextureList();
    // this.createCategoryTree();
    this.setEvent();
    this.setInit();
  }

  /*
  * 操作状態の復元
  */
  setInit() {
    (document.querySelector('#dialogTextureAndItemStarts2D .dialogBody') as HTMLElement).style.overflowY = 'hidden';
    (document.querySelector('#dialogTextureAndItemStarts2D .dialogBody .textureWrap') as HTMLElement).style.overflowY = 'hidden';
    // (document.querySelector('#dialogTextureAndItemStarts .addItemCategorySelect') as HTMLElement).style.width = `${String(this.$tree.width() + 10)}px`;
  }

  /**
   * テクスチャリストの生成
   */
  private createTextureList() {
    const currentSelection:MasterItemCollection = marietta.webcad.WebCADGlobal.itemManager.getCeilingEndItem(this.target.itemInfo.guid);

    let contents = '';
    if ( 0 < this.alternativeEndItemList.length) {
      contents += '<ul>';
      for (let i = 1; i <= this.alternativeEndItemList.length; i += 1) {
        const alt = this.alternativeEndItemList[i - 1];
        const imgPath = alt.hasOwnProperty('item_thumb_path') ? alt.item_thumb_path : '';
        if (currentSelection && currentSelection.item_id === alt.item_id) {
          contents += `<li data-name="${alt.item_id}" class="btnChangeItem is-active" data-itemid="${i}" data-item3did="${alt.symbol_3d_code}" data-itemindex="${i}">`;
        } else {
          contents += `<li data-name="${alt.item_id}" class="btnChangeItem" data-itemid="${i}" data-item3did="${alt.symbol_3d_code}" data-itemindex="${i}" >`;
        }
        contents += `<button id="changeItem${String(i)}">`;
        contents += '<div class="imbBox">';
        contents += `<img class='itemImgThumb' src="${imgPath}"/>`;
        contents += '<div class="currentFrame"></div>';
        contents += '</button>';
        // contents += `<p><span class="jp">${alternatives[i - 1].name}</span><span class="en">${alternatives[i - 1].nameEn}</span></p>`;
        contents += '</div>';
        contents += '</li>';
      }
      contents += '</ul>';
      document.querySelector('#dialogTextureAndItemStarts2D .textureChangeList').innerHTML = contents;
    }
  }

  /**
   * イベントの生成
   */
  setEvent() {
    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((elem) => {
      elem.addEventListener(EVENT_CLICK, (e) => {
        this.selectTexture(e.currentTarget as HTMLElement);
      });
    });
  }

  /**
   * 検索・詳細表示・適用ボタンのイベント（ダイアログ生成時に1回だけ登録）
   */
  private setTextureSelectEvent(): void {
    this.viewObj.insertAdjacentHTML(INSERT_POSITION_END, ItemDetailUtil.createHtml(ItemDetailUtil.TEXTURE_FIELDS));
    // リストのスクロールで吹き出しとサムネイルの位置がずれるため閉じる
    this.viewObj.addEventListener(EVENT_SCROLL, () => ItemDetailUtil.hide(this.viewObj), true);
    const textureWrap: Element = document.querySelector(TEXTURE_WRAP_SELECTOR);
    ItemSearchUtil.bindInput(textureWrap, (query: string) => {
      ItemDetailUtil.hide(this.viewObj);
      const matched: Set<string> = ItemSearchUtil.applyToList(textureWrap, this.alternativeEndItemList, query);
      // 選択中のアイテムが検索で隠れたら、見えないまま適用されないよう選択を外す
      if (this.selectedEndItem && !matched.has(String(this.selectedEndItem.item_id))) this.clearSelection();
    });
    document.getElementById(ItemDetailUtil.CANCEL_BUTTON_ID).addEventListener(EVENT_CLICK, () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });
    const applyButton: HTMLElement = document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID);
    ItemDetailUtil.setApplyEnabled(applyButton, false);
    applyButton.addEventListener(EVENT_CLICK, () => {
      if (!this.selectedEndItem) return;
      marietta.webcad.WebCADGlobal.itemManager.updateCeilingEndItem(this.target.itemInfo.guid, this.selectedEndItem);

      // 見積リストの更新
      marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

      this.close();
    });
  }

  /**
   * サムネイルの選択と詳細の表示
   */
  private selectTexture(elem: HTMLElement): void {
    const itemId: string = elem.getAttribute(ITEM_ID_ATTRIBUTE);
    const master: MasterItemCollection = this.alternativeEndItemList.find((item) => String(item.item_id) === itemId);
    if (!master) return;
    this.selectedEndItem = master;

    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((item) => item.classList.remove(ACTIVE_CLASS));
    elem.classList.add(ACTIVE_CLASS);
    ItemDetailUtil.fill(this.viewObj, master);
    ItemDetailUtil.show(this.viewObj, elem);
    ItemDetailUtil.setApplyEnabled(document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID), true);
  }

  /**
   * 選択の解除
   */
  private clearSelection(): void {
    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((item) => item.classList.remove(ACTIVE_CLASS));
    this.selectedEndItem = null;
    ItemDetailUtil.hide(this.viewObj);
    ItemDetailUtil.setApplyEnabled(document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID), false);
  }

  /**
   * ダイアログを閉じる
   */
  closeEvent() {
    // 操作状態の保存
    const tabId = TextureAndItemDialogStarts2D.tabId;
    TextureAndItemDialogStarts2D.tabId = tabId;

    this.viewObj.remove();
    if (this.showHeaderCloseButton) {
      this.viewObj.querySelector('.dialogCloseBtn').removeEventListener('click', this.close);
    }

    // コールバックのお掃除関数
    if (this.globalCleanUpFunc) this.globalCleanUpFunc();

    if (this.prevDialog) {
      marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
      if (marietta.webcad.WebCADGlobal.currentDialog.hasModal)marietta.webcad.WebCADGlobal.currentDialog.handleModal();
    }

    // 3Dの場合
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    }

    // モーダルのデザインを元に戻す
    document.getElementById('modalBg').style.backgroundColor = '#000';
    document.getElementById('modalBg').style.opacity = '.6';
    document.getElementById('modalBg').style.pointerEvents = 'auto';
  }
}
